module.exports = __webpack_public_path__ + "static/media/amusement(14).2534ebfd.PNG";